import { render, staticRenderFns } from "./TableColumnOrder.component.vue?vue&type=template&id=0fc4a618&scoped=true&lang=pug"
import script from "./TableColumnOrder.component.vue?vue&type=script&lang=ts"
export * from "./TableColumnOrder.component.vue?vue&type=script&lang=ts"
import style0 from "./TableColumnOrder.component.vue?vue&type=style&index=0&id=0fc4a618&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fc4a618",
  null
  
)

export default component.exports